'use strict';
try {
    module.exports = function () {
        throw new Error('Cannot find module \'utf-8-validate\' from \'/development/rtc.io/rtc/node_modules/rtc-quickconnect/node_modules/rtc-pluggable-signaller/node_modules/rtc-switchboard-messenger/node_modules/messenger-ws/node_modules/ws/lib\'');
    }();
} catch (e) {
    module.exports = require('./Validation.fallback');
}